import { GetState, SetState } from "zustand";
import { StoreSlice } from "../index";
import { getFromStorage, saveToStorage } from "../../utils/storage";

export interface AuthStateType {
  accessToken: string | null;
  setAccessToken: (arg: string) => void;
  userId: string | null;
  setUserId: (arg: string) => void;
  refreshToken: string | null;
  setRefreshToken: (arg: string) => void;
  isPreviewMode: boolean;
  setIsPreviewMode: (arg: boolean) => void;

  // Push notification subscription
  pushSubscription: any | null;
  setPushSubscription: (subscription: any) => void;
  notificationPreferences: {
    weddingReminders: boolean;
    rsvpReminders: boolean;
    asoebiUpdates: boolean;
    scheduleUpdates: boolean;
    giftNotifications: boolean;
  };
  setNotificationPreferences: (preferences: any) => void;
}

const authSlice: StoreSlice<AuthStateType> = (
  set: SetState<AuthStateType>,
  get: GetState<AuthStateType>
) => ({
  accessToken: typeof window !== "undefined" ? getFromStorage("acc") : "",
  setAccessToken: (arg: string) => {
    set(() => ({ accessToken: arg }));
    if (typeof window !== "undefined") {
      saveToStorage("acc", arg);
    }
  },
  userId: typeof window !== "undefined" ? getFromStorage("userId") : "",
  setUserId: (arg: string) => {
    set(() => ({ userId: arg }));
    if (typeof window !== "undefined") {
      saveToStorage("userId", arg);
    }
  },
  refreshToken: typeof window !== "undefined" ? getFromStorage("ref") : "",
  setRefreshToken: (arg: string) => {
    set(() => ({ refreshToken: arg }));
    if (typeof window !== "undefined") {
      saveToStorage("ref", arg);
    }
  },
  isPreviewMode: false,
  setIsPreviewMode: (arg: boolean) => {
    set(() => ({ isPreviewMode: arg }));
  },

  // Push notification subscription
  pushSubscription:
    typeof window !== "undefined" ? getFromStorage("pushSub") : null,
  setPushSubscription: (subscription: any) => {
    set(() => ({ pushSubscription: subscription }));
    if (typeof window !== "undefined") {
      saveToStorage("pushSub", subscription);
    }
  },

  notificationPreferences:
    typeof window !== "undefined"
      ? getFromStorage("notifPrefs") || {
          weddingReminders: true,
          rsvpReminders: true,
          asoebiUpdates: true,
          scheduleUpdates: true,
          giftNotifications: true,
        }
      : {
          weddingReminders: true,
          rsvpReminders: true,
          asoebiUpdates: true,
          scheduleUpdates: true,
          giftNotifications: true,
        },
  setNotificationPreferences: (preferences: any) => {
    set(() => ({ notificationPreferences: preferences }));
    if (typeof window !== "undefined") {
      saveToStorage("notifPrefs", preferences);
    }
  },
});

export default authSlice;
